// Whether commission figures are actually on screen right now.
//
// Two separate questions:
//   1. MAY this person ever see commissions?  -> canSeeCommissions (roles.js)
//   2. Are they revealed at this moment?      -> this module
//
// Client Care must reveal them each session, and the reveal is deliberately
// stored in sessionStorage and cleared at login, so it never survives a
// re-login. Team Lead and Accountant skip the reveal entirely.

import { canSeeCommissions, requiresCommissionReveal } from "./roles";

const KEY = "tes.commissionsRevealed";

const listeners = new Set();

export function isRevealed() {
  try {
    return window.sessionStorage.getItem(KEY) === "1";
  } catch (err) {
    // Private mode / storage disabled: fail closed.
    return false;
  }
}

export function setRevealed(value) {
  try {
    if (value) window.sessionStorage.setItem(KEY, "1");
    else window.sessionStorage.removeItem(KEY);
  } catch (err) {
    /* storage unavailable; the in-memory listeners still fire */
  }
  listeners.forEach((fn) => fn());
}

// Call on login so a fresh session always starts hidden.
export function clearReveal() {
  setRevealed(false);
}

export function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

// Pure decision, injectable `revealed` so it can be tested without storage.
export function commissionsVisible(user, revealed) {
  if (!canSeeCommissions(user)) return false;
  if (!requiresCommissionReveal(user)) return true;
  return Boolean(revealed);
}

// True when this user should be offered a show/hide control.
export function showsRevealToggle(user) {
  return canSeeCommissions(user) && requiresCommissionReveal(user);
}
